import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {environment} from '../../environments/environment';
import {ReviewService} from './review.service';

/**
 * Service for the /investigate endpoint (complaint investigation assignments).
 * Extends ReviewService but uses a different base URL and meta defaults.
 * Not provided in root — instantiated per-component to avoid shared-state collisions.
 */
@Injectable()
export class InvestigateService extends ReviewService {

  public override meta: {[key: string]: any} = {
    // verbose_name_plural: 'Investigation Assignments',
    // verbose_name: 'Investigation Assignment',
    display_fields: ['reviewer', 'status', 'reason', 'order', 'last_edited_date'],
    type: 'investigate',
    isLoading: false,
    fields: {
      status: {
        get_choices: (_item) => {
          return Promise.resolve(this.meta.fields.status.choices ?? []);
        }
      }
    }
  };

  constructor(http: HttpClient, modalService: NgbModal) {
    super(http, modalService);
    this.baseUrl = `${environment.baseUrl}/investigate`;
  }
}


